import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 1rem 0 2rem;
  justify-content: center;
  position: relative;

  .tempstars-logo-icon {
    position: relative;
    height: 3rem;
    overflow: hidden;
    flex-shrink: 0;
    max-width: 10rem;
  }

  .arrowIcon {
    height: 1rem;
    padding-right: 0.5rem;
  }

  .yellowBackButton {
    margin: 0 1rem;
    line-height: 1.5rem;
    color: var(--primary-main, #FB7672);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.4px;
    display: flex;
    align-items: center;
    position: absolute;
    background-color: unset;
    border: unset;
    align-self: flex-start;
    font-family: var(--fontMain) !important;
    cursor: pointer;
    background: unset;
    border: unset;
  }

    @media only screen and (max-width: 400px) {
        padding: 1.5rem 0;
        
        .tempstars-logo-icon {
            max-width: 8.75rem;
        }
        .yellowBackButton {
            margin: 0 0.5rem;
        }
    }

    @media only screen and (max-width: 375px) {
        .yellowBackButton {
            margin: 0;
        } 
    }
`